<template>
	<div
		v-if="data.settings != undefined"
		:class="{
			'modal-dialog': noModal === undefined,
			'modal-lg':
				data.settings.width == 'modal-lg' && noModal === undefined,
			'modal-md':
				data.settings.width == 'modal-md' && noModal === undefined,
			'modal-sm':
				data.settings.width == 'modal-sm' && noModal === undefined,
		}"
	>
		<div :class="{ 'modal-content': noModal === undefined }">
			<div v-if="noHeader === undefined" class="modal-header">
				<button
					v-if="
						data.settings.cancelButton ||
						$route.path == '/sms/supervisao'
					"
					type="button"
					class="close"
					data-dismiss="modal"
					aria-label="Close"
				>
					<span aria-hidden="true">&times;</span>
				</button>

				<h4 class="modal-title">
					<i
						class="fa fa-exclamation-circle text-danger"
						v-if="data.settings.required"
						title="Formulário obrigatório!"
						aria-hidden="true"
					></i>
					{{ data.settings.title }}
				</h4>
			</div>
			<!-- Modal footer ===================================== -->

			<div class="modal-body">
				<ul
					v-if="
						data.abas.list != undefined &&
						data.abas.list.length >= 1
					"
					class="nav"
					:class="data.abas.type"
				>
					<li
						v-for="(aba, id) in data.abas.list"
						@click="data.abas.active = aba.id"
						:class="
							data.abas.active == aba.id ||
							(data.abas.active == '' && id == 0)
								? 'active'
								: ''
						"
					>
						<a>{{ aba.titulo }}</a>
					</li>
				</ul>
				<br v-if="data.abas.list.length >= 1" />
				<div class="col-xs-12">
					<!-- {{data.abas.active}} -->
					<span v-if="data.inputs.length == 0">...</span>
					<div class="row">
						<div
							class="hoverMe"
							:class="'col-sm-' + input.col"
							v-for="(input, id) in renderInputs"
							@click="openInput(input, id)"
						>
							<span v-if="input.type != 'msg'">{{
								input.label
							}}</span>
							<ch-input :data="input"></ch-input>
							<ch-select :data="input"></ch-select>
							<ch-textarea :data="input"></ch-textarea>
							<ch-table :data="input"></ch-table>
							<ch-alert :data="input"></ch-alert>

							<!-- <pre>{{input}}</pre> -->
						</div>
					</div>
					<br v-if="data.abas.list.length >= 1" />
					<div class="clearfix"></div>
				</div>
				<div class="clearfix"></div>
			</div>

			<!-- Modal footer ===================================== -->
			<div
				class="modal-footer"
				v-if="
					noFooter === undefined &&
					(data.settings.cancelButton ||
						data.settings.saveButton ||
						data.settings.mailButton ||
						data.settings.printButton)
				"
			>
				<action-button
					v-for="(item, index) in settingsBtns"
					:key="index"
					v-bind="item"
					@click="emitAction(index)"
				/>
			</div>
		</div>
	</div>
</template>
<script>
	// import tools from "../../../../functions/functions.js"

	// Import inputs
	import ChInput from '../inputs/chInputs.vue';
	import ChSelect from '../inputs/chSelect.vue';
	import ChTextarea from '../inputs/chTextarea.vue';
	import ChTable from '../inputs/table.vue';
	import ChAlert from '../inputs/ch-alert.vue';
	import ActionButton from './action-button.vue';

	import _ from 'lodash';

	export default {
		name: 'LogModalForm',
		data() {
			return {
				settingsBtns: {
					cancelar: {
						text: 'Cancelar',
						icon: 'fa fa-close',
						class: 'btn btn-default pull-left',
						vIf: () => this.data.settings.cancelButton,
						loading: false,
						disabled: () => false,
					},
					salvar: {
						text: 'Salvar',
						icon: 'fa fa-save',
						class: 'btn btn-primary',
						vIf: () => this.data.settings.saveButton,
						loading: false,
						disabled: () => false,
					},
					imprimir: {
						text: 'Imprimir',
						icon: 'fa fa-print',
						class: 'btn btn-warning',
						vIf: () => this.data.settings.printButton,
						loading: false,
						disabled: () => this.data.settings.printInfo == '',
					},
					enviarEmail: {
						text: 'Enviar email',
						icon: 'fa fa-save',
						class: 'btn btn-info',
						vIf: () => this.data.settings.mailButton,
						loading: false,
						disabled: () => false,
					},
				},
			};
		},
		props: ['chForm', 'noHeader', 'noFooter', 'noModal'],
		components: {
			ChTable,
			ChInput,
			ChSelect,
			ChTextarea,
			ChAlert,
			ActionButton,
		},
		computed: {
			data() {
				return this.chForm;
			},
			renderInputs() {
				let preList = this.chForm.inputs.filter((item, id) => {
					if (this.chForm.abas.list.length == 0) {
						return item;
					} else {
						if (
							item.aba == this.chForm.abas.active ||
							this.chForm.abas.active == ''
						) {
							return item;
						}
					}
				});
				return _.orderBy(preList, ['order'], ['desc']);
			},
			getData() {
				let retutnData = [];
				this.data.inputs.forEach((item) => {
					if (item.type != 'msg') {
						retutnData.push({
							id: item.id,
							value: item.value,
							cod_form: this.data.cod,
						});
					}
				});
				return retutnData;
			},
		},

		methods: {
			toggleStatusBtn(btn = null, status) {
				if (!btn)
					console.log('cancelar, salvar, imprimir, enviarEmail');
				else
					this.settingsBtns[btn].loading =
						!this.settingsBtns[btn].loading;
			},
			emitAction(btn) {
				console.log(btn);
				this.$emit(btn, this.getData);
			},
			openInput(data, gid) {
				let id;
				this.data.inputs.forEach((item, rid) => {
					if (item.id == data.id) {
						id = rid;
					}
				});
				this.$emit('openInput', { data: data, id: id });
			},
			clear() {
				this.data.inputs.forEach((item, index) => {
					if (item.type == 'checkbox' || item.type == 'table') {
						this.$set(this.data.inputs[index], 'value', []);
					} else {
						this.$set(this.data.inputs[index], 'value', '');
					}
				});
			},
			load(data) {
				setTimeout((e) => {
					data.forEach((item) => {
						if (item.cod_form == this.data.cod) {
							let index = this.data.inputs.findIndex(
								(e) => e.id == item.id
							);
							if (index != -1) {
								this.$set(
									this.data.inputs[index],
									'value',
									item.value
								);
							}
						}
					});
				}, 100);
			},
		},
	};
</script>
<style scoped>
	/* .hoverMe {
		padding: 5px 10px;
		cursor: pointer;
	} */
	/* .hoverMe:hover {
		background-color: aliceblue;
	} */
	.nav > li > a {
		cursor: pointer;
		padding: 6px 15px;
	}
</style>



// WEBPACK FOOTER //
// src/components/models/create-form/components/mdFormLoad.vue